// eslint-disable-next-line import/prefer-default-export
export const generateLinkDocumentById = ({ fileId, documentsKeys, souscriptionId }) => {
  const contractFileLinkId = fileId;
  const getKeyForFile = documentsKeys[fileId];
  const encodedKey = encodeURIComponent(getKeyForFile);

  return `${process.env.REACT_APP_API_URL}/souscriptions/${souscriptionId}/contract/${contractFileLinkId}/downloadWithKey?key=${encodedKey}`;
};
